import { render, staticRenderFns } from "./ShareDelete.vue?vue&type=template&id=30814038&"
import script from "./ShareDelete.vue?vue&type=script&lang=js&"
export * from "./ShareDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports